<template>
    <div>
        <div class="row justify-content-md-center">
            <div class="col-md-6">
                <b-input-group>
                    <b-form-input
                        type="text"
                        placeholder="Busca por versión"
                        v-model="search"
                        :formatter="formatter"
                    ></b-form-input>
                    <b-input-group-append>
                        <b-input-group-text>
                            <b-icon icon="search" />
                        </b-input-group-text>
                    </b-input-group-append>
                </b-input-group>
                <div class="mt-4 mb-2">
                    <div v-if="loading" style="text-align: center;">
                        <b-spinner label="Loading..."></b-spinner>
                    </div>
                    <b-list-group>
                        <b-list-group-item
                        v-for="item in orderFilter(filteredVersiones)"
                        :key="item._id"
                        @click="set_version(item)"
                        >
                            <h6 class="text-muted font-weight-light">
                                {{ item.version.name }}
                            </h6>
                            <span class="text-muted text-small text-justify">
                                Clase: {{item.lineas.tipos_vehiculos.name}} &#124; Transmisión: {{get_tipo_caja(item.version.meta_keys.tipo_caja)}}  &#124;
                                Combustible: {{get_combustible(item.version.meta_keys.combustible)}} &#124; Cilindraje:
                                {{item.version.meta_keys.clindraje}} cc &#124; Número de puertas:
                                {{item.version.meta_keys.puertas}} &#124; Capacidad: {{item.version.meta_keys.capacidad}} pasajeros
                                &#124; Potencia: {{item.version.meta_keys.potencia}} HP &#124; Tracción: {{item.version.meta_keys.transmision}}
                            </span>
                        </b-list-group-item>
                    </b-list-group>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {API_VERSIONES, HEADERS} from 'providers/ApiCredentials';
import { mapFields } from "vuex-map-fields";
export default {
    computed: {
        ...mapFields("vender", [
            'asistente_step',
            'titulo_span',
            'selection_data.linea_id',
            'selection_data.linea_name',
            'selection_data.modelo',
            'selection_data.version_id',
            'selection_data.modelorel_id',
            'selection_data.version_name',
            'form_data.versiones'

        ]),
        filteredVersiones: function() {
            return this.versiones.filter((data) => {
                return data.version.name.toLowerCase().includes(this.search.toLowerCase());
            });
        }
    },
    data() {
        return {
            loading: true,
            search:""
        }
    },
    mounted () {
        this.get_versiones();
    },
    methods: {
        get_versiones() {
            var queryString = window.location.search;
            var urlParams = new URLSearchParams(queryString);
            var step = urlParams.get('step');

            axios.get("/vender_filter_step?step="+ step +"&id_linea=" + this.linea_id+ "&modelo=" + this.modelo).then(response => {
                var parsingModelos = _.orderBy(
                    response.data.result.versiones,
                    ["name"],
                    ["asc"]
                );
                this.versiones = parsingModelos;
                this.loading = false;
            });

            var data = {
                id_linea: this.linea_id,
                modelo: this.modelo
            };

            // axios.post(API_VERSIONES,data, HEADERS).then(response => {
            //     var parsingVersiones = _.orderBy(
            //         response.data.versiones,
            //         ["name"],
            //         ["asc"]
            //     );
            //     this.versiones = parsingVersiones;
            //     this.loading = false;
            // });
        },
        set_version(item){
            this.asistente_step = 'color';
            this.titulo_span = 'Seleccione el color'
            this.modelorel_id = item._id;
            this.version_id = item.version._id;
            this.version_name = item.version.name;
            window.history.replaceState(null, null, '?step=5');
        },
        get_combustible(code_combustible) {
            switch (code_combustible) {
                case "GSL":
                    return "Gasolina";
                    break;
                case "DSL":
                    return "Diesel";
                    break;
                case "ELT":
                    return "Electrico";
                    break;
                case "HBD":
                    return "Híbrido";
                    break;
                default:
                    return code_combustible;
            }
        },
        get_tipo_caja(code_caja) {
            switch (code_caja) {
                case "AT":
                    return "Automatica";
                    break;
                case "MT":
                    return "Mecanica";
                    break;
                case "TP":
                    return "Triptonic";
                    break;
            }
        },
        orderFilter(version) {
            var orderFilter = _.orderBy(version, 'version.name', ["asc"]);
            return orderFilter;
        },
        formatter(value) {
            return value.toUpperCase()
        }
    },
};
</script>

<style lang="scss"></style>
